import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router";
import { Row, Form, Col, Button } from "react-bootstrap";
import { useFieldArray, useForm } from "react-hook-form";
import {
  InputControl,
  InputValidationConstants,
  SubmitButtonContent,
  TextAreaControl,
  SelectControl,
  TinymceControl,
  createOptionsFromEnum,
  DateTimeControl,
  NumberControl,
  CheckboxControl,
} from "wup-module1-base";
import { RoutePathConstants, QuestionTypeEnum } from "../../../Constants";
import "../../DragAndDrop.css";
import QuestionnaireDroppables from "./QuestionnaireDroppables";
import { v4 as uuidv4 } from "uuid";

function QuestionnaireForm({
  onSubmit,
  model = null,
  isEdit = false,
  isSubmitting = false,
}) {
  const navigate = useNavigate();
  const {
    register,
    trigger,
    handleSubmit,
    reset,
    setValue,
    getValues,
    watch,
    control,
    formState: { errors, isValid },
  } = useForm({
    mode: "all",
    // defaultValues: {
    //   pages: [
    //     {
    //       id: uuidv4(),
    //       questionnaireId: model?.id,
    //       name: null,
    //       order: 1,
    //       questions: [],
    //     },
    //   ],
    // },
  });
  const questionsFieldArray = useFieldArray({
    control,
    name: "questions",
    keyName: "uuid",
  });

  const pagesFieldArray = useFieldArray({
    control,
    name: "pages",
    keyName: "uuid",
  });

  const {
    append: appendQuestions,
    update: updateQuestions,
    remove: removeQuestions,
    move: moveQuestions,
    replace: replaceQuestions,
    fields: questionsFields,
  } = questionsFieldArray;

  const {
    append: appendPages,
    update: updatePages,
    remove: removePages,
    move: movePages,
    replace: replacePages,
    fields: pagesFields,
  } = pagesFieldArray;

  useEffect(() => {
    if (model !== null) {
      reset(model);
      // if (pagesFields?.length === 0) {
      //   const firstPage = {
      //     id: uuidv4(),
      //     questionnaireId: model?.id,
      //     name: null,
      //     order: 1,
      //   };
      //   appendPages(firstPage);
      // }
    }
  }, [model]);

  useEffect(() => {
    if (model !== null && pagesFields?.length === 0 && !isEdit) {
      const firstPage = {
        id: uuidv4(),
        questionnaireId: model.id,
        name: null,
        order: 1,
      };
      appendPages(firstPage);
    }
  }, [model]);

  useEffect(() => {
    trigger();
  }, [trigger, pagesFields, questionsFields]);

  const submitForm = (questionnaire) => {
    //console.log(questionnaire);
    const toSubmit = prepareDataForRequest(questionnaire);
    //console.log(toSubmit);
    onSubmit(toSubmit);
  };

  const prepareDataForRequest = (data) => {
    const obj = { ...data };
    if ("redirectNr" in obj) {
      delete obj.redirectNr;
    }
    const allAnswers = [];
    obj.questions.forEach((question) => {
      allAnswers.push(...question.answers);
    });
    obj.allAnswers = allAnswers;
    obj.questions = obj.questions.map((question, index) => {
      if ("uuid" in question) {
        delete question.uuid;
      }
      const relatedQuestions = question.relatedQuestions.map((related) => {
        if ("uuid" in related) {
          delete related.uuid;
        }
        return { ...related };
      });
      return {
        ...question,
        order: index + 1,
        relatedQuestions: relatedQuestions,
      };
    });
    obj.pages = obj.pages.map((page, index) => {
      if ("uuid" in page) {
        delete page.uuid;
      }
      return { ...page, order: index + 1 };
    });
    return obj;
  };

  return (
    <>
      <Form onSubmit={handleSubmit(submitForm)}>
        <Row>
          <Col md={12}>
            <InputControl
              id={"name"}
              label={"Nazwa ankiety"}
              readOnly={false}
              refs={{
                ...register("name", {
                  required: InputValidationConstants.required,
                  maxLength: {
                    value: 100,
                    message: InputValidationConstants.maxLength.replace(
                      "{placeholder}",
                      100
                    ),
                  },
                }),
              }}
              errors={errors}
            />
          </Col>
        </Row>
        {!!model && (
          <QuestionnaireDroppables
            appendPages={appendPages}
            updatePages={updatePages}
            movePages={movePages}
            removePages={removePages}
            pagesFields={pagesFields}
            appendQuestions={appendQuestions}
            updateQuestions={updateQuestions}
            moveQuestions={moveQuestions}
            removeQuestions={removeQuestions}
            questionsFields={questionsFields}
            questionnaireId={model?.id}
            register={register}
            errors={errors}
            getValues={getValues}
            replaceQuestions={replaceQuestions}
          />
        )}
        <Row>
          <Col md={12}>
            <Button
              type="submit"
              variant="primary"
              disabled={!isValid || isSubmitting}
            >
              <SubmitButtonContent
                isSubmitting={isSubmitting}
                condition={isEdit}
              />
            </Button>
            <Button
              className="mx-2"
              type="button"
              variant="secondary"
              onClick={() => navigate(`/${RoutePathConstants.Questionnaire}`)}
            >
              Powrót
            </Button>
          </Col>
        </Row>
      </Form>
    </>
  );
}

export default QuestionnaireForm;
